import {
    GET_TRANSACTION_PROVISION_SETTLE_LIST,
    GET_TRANSACTION_PROVISION_SETTLE_SEARCH,
    GET_TRANSACTION_PROVISION_SETTLE_LIST_SUCCESS,
    TRANSACTION_PROVISION_SETTLE_API_ERROR,
    GET_TRANSACTION_PROVISION_SETTLE_SEARCH_SUCCESS,
    
} from "./actionTypes"

const INIT_STATE = {
    recordList: [],
    error: {},
    loading: false,
    recordListAmount: []
}

const transactionProvisionSettle = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TRANSACTION_PROVISION_SETTLE_LIST:
        case GET_TRANSACTION_PROVISION_SETTLE_SEARCH:
            return {
                loading: true
            }
        case GET_TRANSACTION_PROVISION_SETTLE_LIST_SUCCESS:
        case GET_TRANSACTION_PROVISION_SETTLE_SEARCH_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
                loading: false
            }
        
        case TRANSACTION_PROVISION_SETTLE_API_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        default:

            return state

    }
}

export default transactionProvisionSettle